/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const landingPageSlice = createSlice({
  name: 'landingPage',
  initialState: {
    postalCode: '',
    wasValidatedBefore: false,
  },
  reducers: {
    setPostalCode(state, { payload }) {
      state.postalCode = payload.postalCode;
      state.wasValidatedBefore = true;
    },
  },
});

export const landingPageActions = landingPageSlice.actions;

export default landingPageSlice;
/* eslint-disable no-param-reassign */
